import { Check } from "lucide-react";
import { Icon } from "@/advisor/icons";

export const OptionGrid = ({ options, value, onToggle, prefix, cols = "grid-cols-2 sm:grid-cols-3" }) => (
  <div className={`grid ${cols} gap-3`}>
    {options.map((o) => {
      const active = value.includes(o.key);
      return (
        <button
          key={o.key}
          onClick={() => onToggle(o.key)}
          data-active={active}
          data-testid={`${prefix}-${o.key}`}
          className="adv-option relative p-4 min-h-[96px] flex flex-col justify-between gap-3"
        >
          {o.icon ? (
            <span className={`h-9 w-9 rounded-xl grid place-items-center ${active ? "bg-[#D6AD62] text-[#111110]" : "bg-white/5 text-[#F3D592]"}`}>
              <Icon name={o.icon} className="h-5 w-5" />
            </span>
          ) : (
            <span className={`h-6 w-6 rounded-md border grid place-items-center ${active ? "bg-[#D6AD62] border-[#D6AD62] text-[#111110]" : "border-white/20"}`}>
              {active && <Check className="h-4 w-4" />}
            </span>
          )}
          <span className="font-medium text-sm sm:text-base leading-snug text-[#F3EEE4]">{o.label}</span>
          {o.icon && active && <Check className="absolute top-3 right-3 h-4 w-4 text-[#F3D592]" />}
        </button>
      );
    })}
  </div>
);
